module.exports = __webpack_public_path__ + "static/img/logo.086fdb59.png";